<template>
    <InputSelect
      classField="field mb-0"
      name="Modello"
      :modelValue="modelValue"
      @update:modelValue="value => $emit('update:modelValue', value)"
      :options="$store.state.implant_models.map(({ name }) => name)"
    >
      <button class="button is-primary" type="button" @click="openModalFiles = true" title="Allegati" :disabled="!modelValue"><span v-if="$store.getters.modelFiles(modelValue).length" class="mr-2">{{ $store.getters.modelFiles(modelValue).length }}</span><font-awesome-icon icon="paperclip" class="m-0" /></button>
      <button class="button is-success" type="button" @click="openModalNewModel = true" title="Aggiungi"><font-awesome-icon icon="plus" class="m-0" /></button>
    </InputSelect>
  
    <Modal :title="'Aggiungi modello'" :openModal="openModalNewModel" @close="openModalNewModel = false" @success="addModel()" :loading="loading">
      <div class="field">
        <label class="label">Modello</label>
        <div class="control">
          <input class="input" type="text" placeholder="Modello" v-model="newModel" />
        </div>
      </div>
    </Modal>

    <Modal :title="'Gestione allegati modello'" :openModal="openModalFiles" @close="openModalFiles = false" :noAction="true">
      <FileList v-if="openModalFiles" :id="modelValue" type="setting/model" />
    </Modal>
  </template>
  
  <script>
  export default {
    props: {
      modelValue: String
    },
    emits: ['update:modelValue'],
  
    data() {
      return {
        openModalNewModel: false,
        newModel: '',
        loading: false,

        openModalFiles: false
      }
    },
  
    methods: {
      addModel() {
      const self = this

      if (this.$store.state.implant_models.find(model => model.name.toUpperCase() === self.newModel.toUpperCase())) {
        alert('Modello già esistente!')
        return false
      }

      this.loading = true

      this.$http.post('/setting/add-model', { name: self.newModel })
      .then(function (response) {
        if (response && response.data) {
          self.$store.commit('setSettings', [response.data])
          
          self.$emit('update:modelValue', self.newModel)

          self.openModalNewModel = false
          self.newModel = ''
          self.loading = false
        }
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
        self.loading = false
      })
    },
    }
  }
  </script>